var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.31,
    height: 20.311,
    viewBox: "0 0 20.31 20.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-phone",
    d: "M19.8,14.98l-2.525-2.525a1.787,1.787,0,0,0-2.525,0L13.6,13.6a1.354,1.354,0,0,1-1.913,0L6.714,8.625a1.352,1.352,0,0,1,0-1.913L7.861,5.564a1.784,1.784,0,0,0,0-2.526L5.336.522a1.787,1.787,0,0,0-2.523,0l-.92.912a6.445,6.445,0,0,0,0,9.1l7.882,7.886a6.434,6.434,0,0,0,9.1,0l.918-.918A1.787,1.787,0,0,0,19.8,14.98ZM3.653,1.364a.6.6,0,0,1,.842,0L7.02,3.881a.6.6,0,0,1,0,.842L6.6,5.143,3.234,1.779Zm6.964,16.218L2.735,9.7a5.232,5.232,0,0,1-.328-7.061L5.761,5.989a2.54,2.54,0,0,0,.111,3.477l4.974,4.979h0a2.54,2.54,0,0,0,3.477.111l3.355,3.355A5.222,5.222,0,0,1,10.617,17.582Zm8.34-.918-.421.421-3.367-3.367.421-.421a.6.6,0,0,1,.842,0l2.525,2.525A.6.6,0,0,1,18.957,16.664Z",
    transform: "translate(-0.011 0)",
    fill: "#1b214a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.641d8d326d4f11ebe091cb7f3b5cfdd8.svg";
export { ForwardRef as ReactComponent };